import type { AnvilToolHandlerFunction } from '../handler-function-type'
import type {
  ClientToolCall,
  AnvilToolCall,
  AnvilToolOutput,
} from '@anvil/common/tools/list'

export const handleCodeSearch = (async (params: {
  previousToolCallFinished: Promise<void>
  toolCall: AnvilToolCall<'code_search'>
  requestClientToolCall: (
    toolCall: ClientToolCall<'code_search'>,
  ) => Promise<AnvilToolOutput<'code_search'>>
}): Promise<{
  output: AnvilToolOutput<'code_search'>
}> => {
  const { previousToolCallFinished, toolCall, requestClientToolCall } = params

  await previousToolCallFinished
  return { output: await requestClientToolCall(toolCall) }
}) satisfies AnvilToolHandlerFunction<'code_search'>
